module.exports = __webpack_public_path__ + "img/eraser-icon.7991d8fd.png";